import React from "react";
import styled from "styled-components";
import { bool, func, object, oneOfType, string } from "prop-types";

import TitleContainer from "../Title";
import AddressTextField from "../../shared/AddressTextField";

import { addressType } from "@types";
import { desktop } from "@components/shared/utils";

const Container = styled.div`
  margin-top: 1rem;
  margin-bottom: -6rem;
  text-align: center;
  z-index: 10;
  padding: 1rem 2rem;

  ${desktop`
    margin-bottom: 0;
  `}
`;

const TitleSection = ({
  typesContainerRef,
  setIsTypeExplanationOpen,
  defaultColor,
  shouldRenderAddress,
  address,
  onResetAddress,
  onSetAddress,
  accentColor,
}) => (
  <Container>
    <TitleContainer
      typesContainerRef={typesContainerRef}
      setIsTypeExplanationOpen={setIsTypeExplanationOpen}
      textColor={defaultColor}
    />
    {shouldRenderAddress && (
      <AddressTextField
        initialValue={address}
        onResetAddress={onResetAddress}
        onSetAddress={onSetAddress}
        customColor={accentColor}
      />
    )}
  </Container>
);

TitleSection.propTypes = {
  typesContainerRef: object.isRequired,
  setIsTypeExplanationOpen: func.isRequired,
  defaultColor: string.isRequired,
  shouldRenderAddress: bool.isRequired,
  address: oneOfType([addressType, string]),
  onResetAddress: func.isRequired,
  onSetAddress: func.isRequired,
  accentColor: string.isRequired,
};

export default TitleSection;
